import HeadLines from "../../../CommonComponents/HeadLines";
import Switch from "../../../CommonComponents/Switch/Switch";
import style from "./style.module.css";

const MobileTableView = ({
  data,
  customClass,
  customKeyStyle,
  customValueStyle,
  children,
  headers,
  actionComponents = [],
  handleBillingSwitchChange,
}) => {
  return (
    <>
      {data && data.length > 0 && (
        <>
          {data.map((item, index) => (
            <div key={index}>
              {children}
              <div className={customClass || style.mobileCard}>
                {/* Iterate through keys of the item */}
                {Object.keys(item).map((key) => (
                  <div key={key} className={style.cardRow}>
                    <div
                      className={`${customKeyStyle || style.keyStyle} ${
                        style.cardRowFontStyle
                      }`}
                    >
                      <HeadLines text={key} />
                    </div>
                    {/* Render actionComponents if the key is "Actions" */}
                    {key === "Actions" && headers?.includes("Actions") ? (
                      <div className={style.actionContainer}>
                        {actionComponents[index] || "--"}
                      </div>
                    ) : key === "Receive Billing Information" ? (
                      <div style={{ flex: 1, paddingLeft: " 12px" }}>
                        <Switch
                          id={`billing-info-switch-${index}`}
                          checked={
                            item[key]?.label === "TRUE" ||
                            item[key]?.label === true
                          } // Check the label value
                          onChange={(e) =>
                            handleBillingSwitchChange(e.target.checked, index)
                          }
                        />
                      </div>
                    ) : (
                      <span
                        className={`${customValueStyle || style.valueStyle} ${
                          item[key]?.className || ""
                        } ${style.cardRowFontStyle}`}
                      >
                        {item[key]?.label || "--"}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default MobileTableView;
